<template>
  <div class="ui container view">
    <div class="ui two column centered grid">
      <div class="column">
        <div class="ui raised segment">
          <h3>Create a New Quote</h3>
          <div v-if="flashIsActive" v-bind:class="flash.type" class="ui message">
            <div class="header">
              {{ flash.type | capitalize }}
            </div>
            <p>{{ flash.message }}</p>
          </div>
          <div v-else>
            <p>Use one of the templates below as a starting point for your new quote.</p>
            <div class="ui divider"></div>
            <div class="ui relaxed divided selection list">
              <a v-for="quoteTemplate in quoteTemplates" class="item" @click="loadQuote(quoteTemplate)">
                <i class="large file text middle aligned icon"></i>
                <div class="content">
                  <div class="ui tiny blue header">{{ quoteTemplate.title }}</div>
                  <div class="description">{{ quoteTemplate.description }}</div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  computed: {
    quoteTemplates () {
      return this.$store.getters.fetchQuoteTemplates
    },

    flash () {
      return this.$store.getters.flash
    },

    flashIsActive () {
      return this.$store.getters.flashIsActive
    }
  },

  methods: {
    setQuoteMeta () {
      if (!_.isEmpty(this.$route.query)) {
        this.$store.commit('SET_QUOTE_META', this.$route.query)
        this.$store.commit('SET_AUTH_TOKEN', this.$route.query.auth_token)
        if (this.$store.getters.quoteTemplatesAreNotSet) {
          this.$store.dispatch('fetchQuoteTemplates')
        }
      } else {
        this.$store.commit('SET_FLASH', {
          type: 'error',
          message: 'The quote meta parameters are missing...'
        })
      }
    },

    loadQuote (quoteTemplate) {
      let payload = JSON.parse(JSON.stringify(quoteTemplate.payload))
      this.$store.commit('UPDATE_QUOTE', { payload: JSON.stringify(payload) })
      this.$store.commit('SET_QUOTE_LOADED')
      this.$router.push({ name: 'dashboard' })
    }
  },

  mounted () {
    this.setQuoteMeta()
  }
}
</script>



// WEBPACK FOOTER //
// New.vue?74c78a7c